const c = (...e) => (o) => {
  e.forEach((r) => {
    r.value = o;
  });
};
export {
  c as composeRefs
};
